import { skipToken } from "@reduxjs/toolkit/query";
import { useSelector } from "react-redux";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import { useGetUserCurrentReviewsQuery } from "../../services/reviews.service";
import { toSubmitGuestReviewCards } from "../services/api/reviews/converter";
import type { SubmitGuestReviewCardData } from "../types/model/submit-guest-review";

export type UseSubmitGuestReviewsResult = {
  cards: SubmitGuestReviewCardData[];
  isError: boolean;
  isLoading: boolean;
  refetch: () => void;
};

/**
 * Fetches the host's pending reviews and shapes the ones they owe about guests
 * into "Submit a review of your guest" cards for the Host Hub recommended
 * section. Skips the request until the profile SSO id is available.
 */
const useSubmitGuestReviews = (): UseSubmitGuestReviewsResult => {
  const ssoId = useSelector(selectProfileSSOid);

  const { data, isError, isLoading, refetch } = useGetUserCurrentReviewsQuery(
    ssoId ? { ssoId } : skipToken,
  );

  return {
    cards: toSubmitGuestReviewCards(data),
    isError,
    isLoading,
    refetch,
  };
};

export default useSubmitGuestReviews;
